const actionTypes = {
  SET_INTEGRATION: '@MYYOLA/HELP_CENTER/SET_INTEGRATION',
};

export default actionTypes;
